module.exports = {
  familyName: 'Nunito Sans 12pt',
  category: 'sans-serif',
  capHeight: 705,
  ascent: 1011,
  descent: -353,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 486,
  xWidthAvg: 449
};
